// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconButton_wrapper__3_AaF","readonly":"IconButton_readonly__1I9BK"};